import {
  MyInfoType,
  UserActionReturnType,
  UserInitialStateType,
} from "DataTypes/Redux";
import { SET_MY_INFO, CLEAR_MY_INFO, CLEAR_USER } from "./type";

const MyInfoInitialState: MyInfoType = {
  id: null,
  firstname: "",
  lastname: "",
  corporateOrg: null,
  userName: "",
  userType: "",
  profileImageUrl: "",
};

const INITIAL_STATE: UserInitialStateType = {
  myInfo: JSON.parse(JSON.stringify(MyInfoInitialState)),
};

const reducer = (state = INITIAL_STATE, action: UserActionReturnType) => {
  switch (action.type) {
    case SET_MY_INFO:
      return {
        ...state,
        myInfo: action.payload,
      };
    case CLEAR_MY_INFO:
      return {
        ...state,
        myInfo: MyInfoInitialState,
      };
    case CLEAR_USER:
      return {
        ...state,
        myInfo: MyInfoInitialState,
        myPermission: {},
        alert: {
          count: 0,
          selected: null,
        },
      };
    default:
      return state;
  }
};

export default reducer;
